export const TYPE = {
  SHOW_EPISODE_CONTAINER: 'SHOW_EPISODE_CONTAINER',
  GET_EPISODES: 'GET_EPISODES',
  LOADING_EPISODES: 'LOADING_EPISODES',
  DELETE_EPISODE: 'DELETE_EPISODE',
};
